//
// sked-custom
// sked-custom-annual
// sked-fundamentals
// sked-fundamentals-annual
// sked-essentials
// sked-essentials-annual
// sked-enterprise
// sked-enterprise-annual
// sked-professional
// sked-professional-annual
//
export const PLANS_FEATURES = {
  'sked-fundamentals': {
    sort: 0,
    shortName: 'fundamentals',
    tooltip:
      'This plan is best for you if you’re starting to get serious about organic Instagram and social media marketing.',
    includedAccounts: ['1 Instagram', '4 other'],
    features: {
      title: 'Tools that do the heavy lifting:',
      value: [
        'Unlimited posts',
        '1 account',
        '1 user',
        'Visual Instagram planner',
        'Basic 30 day analytics',
        'AI caption writing',
      ],
    },
    industry: 'Sole Trader, Small Business Owner',
  },
  'sked-essentials': {
    sort: 1,
    shortName: 'launch',
    tooltip:
      'This plan is best for you if you want to know what’s working, beat your competitors, and push your organic social media marketing further.',
    includedAccounts: ['3 Instagram', '9 other'],
    features: {
      title: 'Tools that do the heavy lifting:',
      value: [
        'Unlimited users with custom permissions',
        'Internal comments and tags',
        'Multi-platform scheduling',
        'All-in-one social inbox',
        'AI assistance',
        'Organic and paid analytics',
        'Social listening summaries',
        'Auto-generated reports',
        'Canva, Google Drive and Dropbox integrations',
        'Link-in-bio page',
        '24/7 live chat + onboarding support',
      ],
    },
    industry: 'E-Commerce, Growing Business, Hospitality',
  },
  'sked-professional': {
    sort: 2,
    shortName: 'grow',
    tooltip:
      'This plan is best for you if your social marketing is team-driven, with internal and/or external collaboration.',
    includedAccounts: ['Starting at 5 Instagram', '15 other'],
    features: {
      title: 'Everything in Launch, plus:',
      value: [
        'Frictionless custom approval workflows',
        'No-login branded review portal',
        'Social Listening audience analytics',
        'Content Labels',
        'Competitor analysis',
        'Instant PDF reports',
        'Raw data export',
        'Dedicated customer success manager',
        'Bulk uploads',
      ],
    },
    industry: 'Agency, PR, Media, Brand Management',
  },
  'sked-enterprise': {
    sort: 3,
    shortName: 'accelerate',
    tooltip: 'Start with enterprise for a custom plan to meet your team needs.',
    includedAccounts: ['Starting at 10 Instagram', '30 other'],
    features: {
      title: 'Everything in Grow, plus:',
      value: [
        'Custom PDF reports with editable AI analysis',
        'Content Labels reporting to segment your data simply',
        'Custom comparison periods',
        'Full suite of Social Listening tools',
        'Whitelabeled link-in-bio',
        'Priority support and dedicated customer success manager',
        'Flexible payment terms on annual contracts',
      ],
    },
    industry: 'Any Industry',
  },
};
